import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import keyIcon from "@iconify/icons-mdi/key";
import { InlineIcon } from "@iconify/react";
import useOcProperty from "oc/hooks/use-property";

interface OcPasswordInputFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: boolean;
  setError: (error: boolean) => void;
  helperText: string;
  setHelperText: (text: string) => void;
  label: string;
}

export const OcPasswordInputField: React.FC<OcPasswordInputFieldProps> = ({
  value,
  onChange,
  error,
  setError,
  helperText,
  setHelperText,
  label,
}) => {
  const theme = useTheme();

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const { data: passwordVisibilityData } = useOcProperty({
    resource: "system",
    key: "passwordVisibility",
  });

  return (
    <TextField
      label={label}
      variant="outlined"
      type={showPassword ? "text" : "password"}
      fullWidth
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      autoComplete={label}
      onFocus={() => {
        setError(false);
        setHelperText("");
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <InlineIcon
              icon={keyIcon}
              height="24px"
              color={theme.palette.gray60.main}
            />
            <Box width="8px" />
            {passwordVisibilityData === "true" && (
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                style={{
                  backgroundColor: theme.palette.gray20.main,
                  height: "48px",
                  width: "48px",
                }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default OcPasswordInputField;
